export class CollectionTypeParams {
    constructor(
        public orderTypeId: Nullable<number> = null,
        public address: Nullable<OLO.DTO.AddressSugestionDto> = null,
        public details?: APICommon.OrderTypeDetailDefinitionExtended[],
    ) {}
}
